import { render } from "./GeneralMetadataComponent.vue?vue&type=template&id=87f55ed8&scoped=true"
import script from "./GeneralMetadataComponent.vue?vue&type=script&lang=js"
export * from "./GeneralMetadataComponent.vue?vue&type=script&lang=js"

import "./GeneralMetadataComponent.vue?vue&type=style&index=0&id=87f55ed8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87f55ed8"]])

export default __exports__